import React, { useState } from "react";

/**
 * Chrome/Edge/Safari ignore autocomplete="off" on anything that looks like a
 * login form, so saved credentials get dropped into "Alternative Email" and
 * "Password" on our edit screens. Two things stop that:
 *
 *  1. <AutofillDecoys /> - a throwaway username/password pair placed first in
 *     the form. The browser fills the first pair it finds, so it fills these.
 *     They must stay in the layout (display:none / hidden fields are skipped),
 *     hence the off-screen wrapper.
 *  2. <NoAutofillInput /> - read-only until the user focuses it. Browsers never
 *     autofill a read-only input, and the lock is released on real interaction.
 *
 * Don't use NoAutofillInput on a required field: constraint validation is
 * barred while an input is read-only, so `required` would not fire.
 */

const hiddenStyle = {
  position: "absolute",
  top: 0,
  left: 0,
  width: 0,
  height: 0,
  opacity: 0,
  overflow: "hidden",
  border: 0,
  padding: 0,
  zIndex: -1,
};

export const AutofillDecoys = () => (
  <div style={hiddenStyle} aria-hidden="true">
    <input
      type="text"
      name="autofill-decoy-username"
      tabIndex={-1}
      autoComplete="username"
    />
    <input
      type="password"
      name="autofill-decoy-password"
      tabIndex={-1}
      autoComplete="current-password"
    />
  </div>
);

export const NoAutofillInput = ({ type = "text", onFocus, ...rest }) => {
  const [locked, setLocked] = useState(true);

  return (
    <input
      {...rest}
      type={type}
      readOnly={locked}
      autoComplete={type === "password" ? "new-password" : "off"}
      autoCorrect="off"
      autoCapitalize="off"
      spellCheck={false}
      data-lpignore="true"
      data-form-type="other"
      onFocus={(e) => {
        setLocked(false);
        if (onFocus) onFocus(e);
      }}
    />
  );
};

export default NoAutofillInput;
